/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { EquipmentType } from '../../../../../models/core/equipment.type';
import { formatTimestampToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: EquipmentType[];
  confirmActionResult(item: EquipmentType, action: string, confirmed: boolean): void;
};

export default function DataView(props: DataViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Equipamento',
      key: 'residuoEquipamento',
      dataIndex: 'residuoEquipamento',
      sorter: (a: EquipmentType, b: EquipmentType) =>
        a.residuoEquipamento.localeCompare(b.residuoEquipamento),
    },
    {
      title: 'Descrição',
      key: 'descricao',
      sorter: (a: EquipmentType, b: EquipmentType) => {
        return (a.descricao || '').localeCompare(b.descricao || '');
      },
      render: (row: EquipmentType) => (
        <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: EquipmentType, b: EquipmentType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: EquipmentType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: EquipmentType, b: EquipmentType) =>
        new Date(a.dataCriacao).valueOf() - new Date(b.dataCriacao).valueOf(),
      render: (row: EquipmentType) => formatTimestampToString(row.dataCriacao),
    },
    {
      title: 'Modificado Por',
      key: 'modificadoPor',
      sorter: (a: EquipmentType, b: EquipmentType) =>
        (a.modificadoPor || '').localeCompare(b.modificadoPor || ''),
      render: (row: EquipmentType) => {
        if (row.idModificadoPor) {
          return (
            <ProfileCardLink id={row.idModificadoPor || ''} name={row.modificadoPor || ''} nameSize="sm" />
          );
        }
        return '-';
      },
    },
    {
      title: 'Data Modificação',
      key: 'dataModificacao',
      sorter: (a: EquipmentType, b: EquipmentType) => {
        const date = new Date();
        return new Date(a.dataModificacao || date).valueOf() - new Date(b.dataModificacao || date).valueOf();
      },
      render: (row: EquipmentType) => {
        if (row.dataModificacao) {
          return formatTimestampToString(row.dataModificacao);
        }
        return '-';
      },
    },
    {
      title: 'Ações',
      width: '130px',
      render: (row: EquipmentType) => (
        <DataViewActions item={row} confirmActionResult={props.confirmActionResult} />
      ),
    },
  ];

  return (
    <Table
      showSorterTooltip={false}
      dataSource={props.data}
      columns={columns}
      rowKey={(item: EquipmentType) => item.idResiduoEquipamento}
      pagination={{
        pageSizeOptions: [10, 25, 50],
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
      }}
    />
  );
}
